<template>
    <div>
        <div v-if="type == 'image' || type == 'youtube'">
            Configuration {{type}}

            <p v-if="column_filter">
                Filtre
                <b-select @change="set_filter" v-model="filter" :options="filters"></b-select>
            </p>

            <edit_tabulator ref="tabulator" :extern_file="false" :columns_type="columns_type"></edit_tabulator>

            <p v-if="column_search">Colonne de recherche : {{column_search}}</p>
            <p>Complément de recherche
                <b-input @change="set_exemple" v-model="search"></b-input>
            </p>

            <p>Exemple : {{exemple_search}}</p>

            <b-button @click="test_api()">Test de recherche sur 10 lignes</b-button>

            <br /><br />
            
            <div v-if="spinner_search" class="center_spinner">
                <fade-loader></fade-loader>
            </div>
            <div v-show="!spinner_search">
                <edit_tabulator ref="search_tabulator" :extern_file="false" :columns_type="columns_type"></edit_tabulator>
            </div>

            <b-tabs>
                <b-tab v-if="column_filter" title="Règles">
                    <rules_block ref="rules" :columns="columns_rules" :options="options"></rules_block>
                </b-tab>
                <b-tab title="Règles générales">
                    <rules_block ref="general_rules" :columns="columns_rules" :options="options" ></rules_block>
                </b-tab>
            </b-tabs>

            <b-button @click="test_rules">Test des règles</b-button>

            <br /><br />

            <div v-if="spinner_rules" class="center_spinner">
                <fade-loader></fade-loader>
            </div>
            <div v-show="!spinner_rules">
                <edit_tabulator ref="result_tabulator" :extern_file="false" :columns_type="columns_type"></edit_tabulator>
            </div>

            <b-button @click="save">Sauvegarder les paramètres</b-button>&nbsp;

            <b-button v-show="!spinner_rules" @click="send_data">Retourner les résultats</b-button>

            <br />
            
            <div v-show="!spinner_rules">

                <span v-for="(action, idx) in actions" :key="idx">
                    <action @launch_treatment="launch_treatment" :source_data="get_data" :action="action"></action>&nbsp;
                </span>

            </div>

            <br /><br />
        </div>
        <div v-else>

            <p>{{ name }} - version : {{ version }}</p>

            <div v-if="type == 'rules'">
                <rules_editor :library="true" ref="element"></rules_editor>
            </div>
            <div v-if="type == 'chatgpt'">
                <chatgpt :library="true" ref="element"></chatgpt>
            </div>

            <br /><br />

            <b-button @click="save">Sauvegarder les paramètres</b-button>&nbsp;

            <br /><br />

        </div>
    </div>

</template>

<script>
    import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	import rules_editor from '../../components/rules_editor.vue'
    import treatments from "../../services/treatments.js";
    import edit_tabulator from "../edit_tabulator.vue";
    import database from "../../services/database.js";
    import workers from "../../services/workers.js";
	import library from "../../services/library.js";
    import chatgpt from '../../views/Chatgpt.vue';
    import rules_block from "../rules_block.vue";
	import users from "../../services/users.js";
    import store from "../../store";
    import images from "../images";
	import videos from "../videos";
    import action from "./action";

	import * as json2csv from "json2csv";
    import moment from "moment";
	import _ from 'lodash';

    var clone = require("clone");

    export default {
        name:"configuration",
        components: {
            edit_tabulator,
            rules_block,
            FadeLoader,
            images,
            videos,
            action,
            chatgpt,
            rules_editor
        },
        props: {
            index: {}
        },
        data: function () {
            return {
                type: "",
                import_data: [],
                import_data_filters: [],
                data: [],
                filters: [],
                filter: "",
                search: "",
                exemple_search: "",

                columns_type: {},
                columns_type_arr: [],
                actions: [],
                
                column_search: "",
                column_filter: "",
                column_result: "",
                column_select: "",

                columns_rules: [],
                options: {
					lowercase: false,
					lists: [],
                    columns_list: {}
                },

                config: null,

                general_filters_db_id: "",
                filters_db_id: "",

                spinner_rules: false,
                spinner_search: false,

                user: {},
                name: "",
                version: ""
            };
        },
        methods: {
            set_exemple()
            {
                this.exemple_search = "";

                var data = this.$refs.tabulator.get_data();

                if (data.length > 0)
                {
                    var q = "";
                    if (this.column_search)
                        q = "${data['" + this.column_search + "']} ";
                    q += this.search;

                    var compiled = _.template(q);
                    this.exemple_search = compiled({ data: data[0] });
                }
            },
            async send_data()
            {
                var data = this.$refs.result_tabulator.get_data();
                for (var i = 0; i < data.length; i++)
                {
                    this.$emit("update_cell", data[i][this.index], this.column_result, data[i][this.column_result]);
                    if (this.column_select)
                        this.$emit("update_cell", data[i][this.index], this.column_select, data[i][this.column_select]);
                }
            },
            async test_rules()
            {
                this.spinner_rules = true;

                var data = this.$refs.search_tabulator.get_data();
                data = clone(data);

                if (this.type == "image" || this.type == "youtube")
                {
                    var general_code = await this.generate_general_code();
                    var code = await this.generate_code();

                    code = `
                    function score(data, type)
                    {
                        ${general_code}
                        ${code};

                        var search = "";
                        var column = "";
                        if (type == "youtube" && data.youtube_channel_link)
                        {
                            search = data.youtube_channel_link;
                        }
                        else if (type == "image" && data.image_link)
                        {
                            search = data.image_link.replace(/(.*\\/\\/.*?\\/).*/, "$1");
                        }
                        if (search)
                        {
                            if (blacklist.includes(search))
                            {
                                data[type + "_score"] += 100;
                            }

                            if (whitelist.includes(search))
                            {
                                data[type + "_score"] -= 100;
                            }
                        }

                        return data;
                    }

                    var blacklist = [];
                    for (var i = 0; i < db.blacklist.length; i++)
                    {
                        blacklist.push(db.blacklist[i].element);
                    }

                    var whitelist = [];
                    for (var i = 0; i < db.whitelist.length; i++)
                    {
                        whitelist.push(db.whitelist[i].element);
                    }

                    var lines = [];
                    var column_result = "${this.column_result}";
                    var column_select = "${this.column_select ? this.column_select : ''}";
                    var type = "${this.type}";

                    for (var i = 0; i < data.length; i++)
                    {
                        data[i][column_result] = JSON.parse(data[i][column_result]);
                    
                        var data_keys = Object.keys(data[i]);
                        for (var j = 0; j < data[i][column_result].length; j++)
                        {
                            var line = clone(data[i]);
                            var keys = Object.keys(data[i][column_result][j]);
                            for (var k = 0; k < keys.length; k++)
                            {
                                line[type + "_" + keys[k]] = data[i][column_result][j][keys[k]];
                            }
                            line[type + "_score"] = line[type + "_position"];
                            for (var k = 0; k < data_keys.length; k++)
                            {
                                if (data_keys[k] != column_result)
                                {
                                    line[data_keys[k]] = data[i][column_result][j][data_keys[k]];
                                }
                            }
                            line = score(line, type);
                            line[type + "_score"] = parseInt(line[type + "_score"]);
                            var keys = Object.keys(data[i][column_result][j]);
                            for (var k = 0; k < keys.length; k++)
                            {
                                if (line.hasOwnProperty(type + "_" + keys[k]))
                                    data[i][column_result][j][keys[k]] = line[type + "_" + keys[k]];
                            }
                        }
                        data[i][column_result] = data[i][column_result].sort(tools.field_sorter(["score"]));

                        if (column_select && data[i][column_result].length > 0)
                        {
                            data[i][column_select] = [data[i][column_result].shift()];
                        }
                    }
                    `;

                    var str_csv = json2csv.parse(data, {
                        fields: Object.keys(data[0]),
                        fieldNames: Object.keys(data[0]),
                    });

                    var files = [
                        new File([str_csv], "data.csv", {
                            type: "text/csv",
                        }),
                    ];

                    var formData = new FormData();
                    formData.append(files[0].name, files[0]);
                    formData.append("action", "fonction");
                    formData.append("parameters", JSON.stringify({
                            code: code,
                            type: "file",
                            db_requests: {
                                blacklist: 'select * from ' + this.config.table_list + ' where type = "blacklist" and ' + this.type + ' is true',
                                whitelist: 'select * from ' + this.config.table_list + ' where type = "whitelist" and ' + this.type + ' is true',
                            }
                    }));
                    
                    var results = await workers.test(formData);

                    var data = await treatments.getFileAlyx(
                        results.data.files[0].url,
                        false,
                        false
                    );
                    let fileName = results.data.files[0].name;
                    
                    data = this.$papa.parse(data, { header: true });
                    data = data.data;

                    this.$refs.result_tabulator.set_data(data, Object.keys(this.columns_type));

                    this.spinner_rules = false;
                }
            },
            async test_api()
            {
                this.spinner_rules = true;
                this.spinner_search = true;

                var data = this.$refs.tabulator.get_data();
                data = clone(data)

                if (this.type == "image" || this.type == "youtube")
                {
                    data = data.slice(0, 10);
                    var str_csv = json2csv.parse(data, {
                        fields: Object.keys(data[0]),
                        fieldNames: Object.keys(data[0]),
                    });

                    var files = [
                        new File([str_csv], "data.csv", {
                            type: "text/csv",
                        }),
                    ];

                    var formData = new FormData();
                    formData.append(files[0].name, files[0], "data.csv");
                    formData.append("action", "api");

                    var q = "";
                    if (this.column_search)
                        q = "${data['" + this.column_search + "']} ";
                    q += this.search;

                    var request = {
                        column_result: "result",
                        column_error: "error",
                        unique: false,
                        uri: "https://serpapi.com/search",
                        qs: [
                            ""
                        ],
                        qs_params: {
                            api_key: "serpapi_key",
                        },
                        options_template: true
                    }

                    if (this.type == "image")
                    {
                        request.qs_params.engine = "google_images";
                        request.qs_params.q = q;
                    }
                    else
                    {
                        request.qs_params.engine = "youtube";
                        request.qs_params.search_query = q;
                    }

                    formData.append("parameters", JSON.stringify(request));

                    var results = await workers.test(formData);

                    var data = await treatments.getFileAlyx(
                        results.data.files[0].url,
                        false,
                        false
                    );
                    let fileName = results.data.files[0].name;
                    
                    data = this.$papa.parse(data, { header: true });
                    data = data.data;                

                    for (var i = 0; i < data.length; i++)
                    {
                        data[i].result = JSON.parse(data[i].result);
                        var urls = [];
                        console.log(data[i])
                        if (data[i].result && data[i].result.images_results)
                        {
                            for (var j = 0; j < data[i].result.images_results.length && j < 100; j++)
                            {
                                urls.push({
                                    id: this.$uuid.v4(),
                                    position: data[i].result.images_results[j].position,
                                    source: data[i].result.images_results[j].source,
                                    title: data[i].result.images_results[j].title,
                                    link: data[i].result.images_results[j].link,
                                    url: data[i].result.images_results[j].original,
                                    width: data[i].result.images_results[j].original_width,
                                    height: data[i].result.images_results[j].original_height,
                                    is_product: data[i].result.images_results[j].is_product,
                                    get_date: moment().format("YYYY-MM-DD"),
                                    score: data[i].result.images_results[j].position
                                });
                            }
                        }
                        if (data[i].result && data[i].result.video_results)
                        {
                            for (var j = 0; j < data[i].result.video_results.length && j < 100; j++)
                            {
                                urls.push({
                                    id: this.$uuid.v4(),
                                    position: data[i].result.video_results[j].position_on_page,
                                    title: data[i].result.video_results[j].title.replace(/\\/, ""),
                                    url: data[i].result.video_results[j].link,
                                    channel_name: data[i].result.video_results[j].channel.name,
                                    channel_link: data[i].result.video_results[j].channel.link,
                                    channel_verified: data[i].result.video_results[j].channel.verified,
                                    description: data[i].result.video_results[j].description,
                                    published_date: data[i].result.video_results[j].published_date,
                                    views: data[i].result.video_results[j].views,
                                    length: data[i].result.video_results[j].length,
                                    extensions: data[i].result.video_results[j].extensions,
                                    thumbnail_static: data[i].result.video_results[j].thumbnail.static,
                                    thumbnail_rich: data[i].result.video_results[j].thumbnail.rich,
                                    get_date: moment().format("YYYY-MM-DD"),
                                    score: data[i].result.video_results[j].position_on_page
                                });
                            }
                        }
                        if (!this.column_result)
                            this.column_result = "result";
                        data[i][this.column_result] = JSON.stringify(urls);
                        if (this.column_result && this.column_result != "result")
                            delete data[i].result
                    }
                    console.log(data)
                    this.$refs.search_tabulator.set_data(data, Object.keys(this.columns_type));

                    this.spinner_search = false;

                    this.test_rules();
                }
            },
            launch_treatment(id, action, data)
            {
                this.$emit("launch_treatment", id, action, data);
            },
            get_data(idx = 0)
            {
                return this.$refs.result_tabulator.get_data();
            },
            async set_filter()
            {
                console.log("set_import_data_filters")
                var self = this;

                this.import_data_filters = this.import_data.filter((data) => data[self.column_filter] == self.filter );
                console.log(this.import_data_filters)
                this.$refs.tabulator.set_data(this.import_data_filters, Object.keys(this.columns_type));
                this.$refs.search_tabulator.set_data(this.import_data_filters, Object.keys(this.columns_type));
                this.$refs.result_tabulator.set_data(this.import_data_filters, Object.keys(this.columns_type));

                var conditions = {};
                conditions[this.column_filter] = this.filter;
                conditions = JSON.stringify(conditions);

                var response = await database.get("select", this.config.tables_filtrers, {
                    select: "*",
                    where: 'conditions = "' + conditions.replace(/"/g, '\\"') + '" and type like "%' + this.type + '%"'
                });

                console.log(response)
                if (response.length > 0)
                {
                    this.search = response[0].filtre;
                    this.filters_db_id = response[0].id;
                    if (response[0].rules)
                    {
                        await this.$refs.rules.load(JSON.parse(response[0].rules));
                    }
                }
                else
                {
                    this.filters_db_id = "";
                    this.search = this.filter;

                    this.$refs.rules.reset();
                }

                this.set_exemple();
            },
            async load(data)
            {
                console.log(data);

                this.type = data.configuration.type;

                if (this.type == 'images')
                    this.type = "image";
                if (this.type == "videos")
                    this.type = "youtube";

                console.log("type : " + this.type)

                if (this.type == 'image' || this.type == 'youtube')
                {
                    this.column_search = data.configuration.column_search;
                    this.column_filter = data.configuration.column_filter;
                    this.column_result = data.configuration.column_result;
                    this.column_select = data.configuration.column_select;
                    this.actions = data.configuration.actions ? data.configuration.actions.actions : []

                    this.columns_type = {}
                    
                    if (data.columns_type)
                    {
                        this.columns_type_arr = data.columns_type;
                        for (var i = 0; i < data.columns_type.length; i++)
                        {
                            this.columns_type[data.columns_type[i].column] = data.columns_type[i];
                        }
                    }
                }
                else
                {
                    this.name = data.configuration.library_element_name;
                    var elements = await library.getby_libelle(
						this.name,
						this.type
                    );
                    var element = elements.element[0];
                    this.version = element.version;
                    
                    var result = await library.load(
                        this.name,
                        this.version,
                        this.type
                    );
                    await this.$refs.element.load(result);
                }
            },
            async load_data(data)
            {
                this.import_data = clone(data);

                if (this.type == 'image' || this.type == 'youtube')
                {
                    this.columns_rules = Object.keys(this.import_data[0]);
                    if (this.type == "image")
                    {
                        this.columns_rules = Object.keys(this.import_data[0]);
                        this.columns_rules.push();
                        this.columns_rules.push("image_position"); 
                        this.columns_rules.push("image_source");
                        this.columns_rules.push("image_title");
                        this.columns_rules.push("image_link");
                        this.columns_rules.push("image_url");
                        this.columns_rules.push("image_width");
                        this.columns_rules.push("image_height");
                        this.columns_rules.push("image_is_product");
                        this.columns_rules.push("image_get_date");
                        this.columns_rules.push("image_ref");
                        this.columns_rules.push("image_score");
                    }
                    else if (this.type == "youtube")
                    {
                        this.columns_rules.push("youtube_position");
                        this.columns_rules.push("youtube_title");
                        this.columns_rules.push("youtube_url");
                        this.columns_rules.push("youtube_channel_name");
                        this.columns_rules.push("youtube_channel_link");
                        this.columns_rules.push("youtube_channel_verified");
                        this.columns_rules.push("youtube_description");
                        this.columns_rules.push("youtube_published_date");
                        this.columns_rules.push("youtube_views");
                        this.columns_rules.push("youtube_length");
                        this.columns_rules.push("youtube_extensions");
                        this.columns_rules.push("youtube_thumbnail_static");
                        this.columns_rules.push("youtube_thumbnail_rich");
                        this.columns_rules.push("youtube_score");
                    }

                    if (!this.column_filter)
                    {
                        this.$refs.tabulator.set_data(this.import_data, Object.keys(this.columns_type));
                        this.$refs.search_tabulator.set_data(this.import_data, Object.keys(this.columns_type));
                        this.$refs.result_tabulator.set_data(this.import_data, Object.keys(this.columns_type));
                    }
                    else
                    {
                        if (!this.columns_type[this.column_filter])
                        {
                            this.columns_type[this.column_filter] = {
                                "column": this.column_filter,
                                "type": "text",
                                "edit": false,
                                "list": "",
                                "width": "250",
                                "params": {
                                    "editor": false,
                                    "width": 250
                                }
                            }
                            this.columns_type_arr.push(this.columns_type[this.column_filter]);
                        }

                        this.filters = [];
                        for (var i = 0; i < this.import_data.length; i++)
                        {
                            if (!this.filters.includes(this.import_data[i][this.column_filter]))
                                this.filters.push(this.import_data[i][this.column_filter]);
                        }
                        if (this.filters.length > 0)
                        {
                            this.filter = this.filters[0];
                            this.set_filter();
                        }
                    }

                    console.log(this.config)

                    var response = await database.get("select", this.config.tables_filtrers, {
                        select: "*",
                        where: 'conditions = "" and type like "%' + this.type + '%"'
                    });

                    if (response.length > 0)
                    {
                        this.general_filters_db_id = response[0].id;
                        if (response[0].rules)
                        {
                            this.$refs.general_rules.load(JSON.parse(response[0].rules));
                        }
                    }

                    var response = await database.get("select", this.config.tables_filtrers, {
                        select: "*",
                        where: 'conditions = "" and type like "%' + this.type + '%"'
                    });

                    if (response.length > 0)
                    {
                        this.general_filters_db_id = response[0].id;
                        if (response[0].rules)
                        {
                            this.$refs.general_rules.load(JSON.parse(response[0].rules));
                        }
                    }
                }
                else
                {
                    await this.$refs.element.load_data(this.import_data);
                }
            },
            async save()
            {
                if (this.type == 'image' || this.type == 'youtube')
                {
                    var code = await this.generate_code();
                    var rules = this.$refs.rules.save();

                    var general_code = await this.generate_general_code();
                    var general_rules = this.$refs.general_rules.save();

                    var conditions = {};
                    conditions[this.column_filter] = this.filter;
                    conditions = JSON.stringify(conditions);

                    if (!this.filters_db_id)
                    {
                        var response = await database.get("insert into", this.config.tables_filtrers, {
                            columns: ['filtre', 'conditions', 'type', 'rules', 'code', 'actif'],
                            data: {
                                filtre: this.search,
                                conditions: conditions,
                                type: JSON.stringify([this.type]),
                                code: code,
                                rules: JSON.stringify(rules),
                                actif: 1
                            }
                        });

                        if (response.insertId)
                        {
                            this.filters_db = this.filters;
                            this.filters_db_id = response.insertId;
                        }
                    }
                    else
                    {
                        var response = await database.get("update", this.config.tables_filtrers, {
                            columns: ['filtre', 'conditions', 'type', 'code', 'rules', 'actif'],
                            set: 'actif = ' + 1 + ', rules = "' + JSON.stringify(rules).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '", code = "' + code.replace(/"/g, '\\"') + '", filtre = "' + this.search.replace(/"/g, '\\"') + '"',
                            where: 'id = ' + this.filters_db_id
                        });
                        this.filters_db = this.filters;
                    }

                    if (!this.general_filters_db_id)
                    {
                        var response = await database.get("insert into", this.config.tables_filtrers, {
                            columns: ['conditions', 'type', 'code', 'rules'],
                            data: {
                                conditions: "",
                                type: JSON.stringify([this.type]),
                                code: general_code,
                                rules: JSON.stringify(general_rules)
                            }
                        });

                        if (response.insertId)
                        {
                            this.general_filters_db_id = response.insertId;
                        }
                    }
                    else
                    {
                        var response = await database.get("update", this.config.tables_filtrers, {
                            columns: ['conditions', 'type', 'code', 'rules'],
                            set: 'rules = "' + JSON.stringify(general_rules).replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '", code = "' + general_code.replace(/"/g, '\\"') + '"',
                            where: 'id = ' + this.general_filters_db_id
                        });
                    }
                }
                else
                {
                    var data = await this.$refs.element.save(false);
                    if (this.env) 
                        data.env = this.user.env;

                    console.log(data.data_db)

                    await library.save(
                        this.name,
                        this.version,
                        data,
                        this.type,
                        this.user.env || null,
                        data.data_db === undefined ? {} : data.data_db,
                        (this.type == 'rules' || 
                            this.type == 'config_characteristic' || 
                            this.type == 'characteristics' || 
                            this.type == 'validation') 
                        ? true : false
                    );
                }
            },
			async generate_code()
			{
				var code = await this.$refs.rules.generate_code();

				return code;
			},
			async generate_general_code()
			{
				var code = await this.$refs.general_rules.generate_code();

				return code;
			},
        },
        mounted: async function () {
			let client = store.state.client

            console.log(client)

            if (client.details && client.details.pages && client.details.pages.green_musicians)
            {
                this.config = client.details.pages.green_musicians;
            }
            else
            {
                this.config = client.details.pages.validation;
            }

            this.user = store.state.user;

            console.log(this.config)
        },
    }


</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }
</style>